// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2dk33","rootCenter":"LoadMoreObserver_rootCenter__3VE8w","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3XgOP"};